import { render, staticRenderFns } from "./PaxelRecycleHowTo.vue?vue&type=template&id=4d058046&"
import script from "./PaxelRecycleHowTo.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports